module.exports = __webpack_public_path__ + "img/fuel.d801fbc2.png";